// extracted by mini-css-extract-plugin
export default {"partners":"style_partners__UfKAW","table_container":"style_table_container__yBpXa","partnersIcon":"style_partnersIcon__sSsoA"};